// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-already-paid .page-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 130%;
}

.page-already-paid .page-description {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  text-align: center;
}

.page-already-paid .contacts-container {
  margin-top: 30px;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}

.page-already-paid .contacts-container a {
  color: var(--main-highlight-color);
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/already-paid.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".page-already-paid .page-title {\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 130%;\n}\n\n.page-already-paid .page-description {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.page-already-paid .contacts-container {\n  margin-top: 30px;\n\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: center;\n}\n\n.page-already-paid .contacts-container a {\n  color: var(--main-highlight-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
